import { useCallback } from "react";
import { FlowActions } from "../../stores/flowStore";
export const useViewWalletFlow = () => {
  return _temp;
};
function _temp(address, t0) {
  const initialTab = t0 === undefined ? "crypto" : t0;
  FlowActions.startFlow({
    type: "view-wallet",
    tab: initialTab,
    address
  });
}